import { t } from "i18next"
import '../../../theme/amchi-theme.css'

export const HospitalDetails = (props) => {
    const { GrievanceField, onChange } = props

    return (
        <section className="am-card am-form-card am-rise am-rise-3">
            <div className="am-form-head">
                <span className="am-form-head-ico"><i className="fa-solid fa-hospital"></i></span>
                <div>
                    <h2>{t('GrievanceRegistration.HospitalDetails')}</h2>
                    <p>माहिती असल्यास भरा — ही सर्व माहिती ऐच्छिक आहे</p>
                </div>
            </div>

            <div className="am-form-body">
                <div className="am-form-grid">

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.HospitalName')}</label>
                        <div className="am-field">
                            <i className="fa-solid fa-hospital"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.HospitalName')}
                                name='HospitalName'
                                value={GrievanceField.HospitalName}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.HospitalAddress')}</label>
                        <div className="am-field am-field--ta">
                            <i className="fa-solid fa-location-dot"></i>
                            <textarea
                                placeholder={t('GrievanceRegistration.HospitalAddress')}
                                name='HospitalAddress'
                                value={GrievanceField.HospitalAddress}
                                onChange={onChange}
                            ></textarea>
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.DoctorName')}</label>
                        <div className="am-field">
                            <i className="fa-solid fa-user-doctor"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.DoctorName')}
                                name='DoctorName'
                                value={GrievanceField.DoctorName}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.DoctorAddress')}</label>
                        <div className="am-field am-field--ta">
                            <i className="fa-solid fa-location-dot"></i>
                            <textarea
                                placeholder={t('GrievanceRegistration.DoctorAddress')}
                                name='DoctorAddress'
                                value={GrievanceField.DoctorAddress}
                                onChange={onChange}
                            ></textarea>
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.ReferredDoctorName')}</label>
                        <div className="am-field">
                            <i className="fa-solid fa-user-nurse"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.ReferredDoctorName')}
                                name='ReferredDoctorName'
                                value={GrievanceField.ReferredDoctorName}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.PatientName')}</label>
                        <div className="am-field">
                            <i className="fa-solid fa-user"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.PatientName')}
                                name='PatientName'
                                value={GrievanceField.PatientName}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.PatientAddress')}</label>
                        <div className="am-field am-field--ta">
                            <i className="fa-solid fa-location-dot"></i>
                            <textarea
                                placeholder={t('GrievanceRegistration.PatientAddress')}
                                name='PatientAddress'
                                value={GrievanceField.PatientAddress}
                                onChange={onChange}
                            ></textarea>
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">{t('GrievanceRegistration.VanNumber')}</label>
                        <div className="am-field">
                            <i className="fa-solid fa-van-shuttle"></i>
                            <input
                                type="text"
                                placeholder={t('GrievanceRegistration.VanNumber')}
                                name='VanNumber'
                                value={GrievanceField.VanNumber}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}
